/**
 * A row that scrolls sideways, with a progress line and two arrows under it.
 * The row itself is a native scroller; this only keeps the controls in step.
 */
class ScrollSlider extends HTMLElement {
  #controller = new AbortController();
  #observer;
  #track;
  #bar;
  #arrows;

  connectedCallback() {
    const { signal } = this.#controller;
    this.#track = this.querySelector('.sda-scroller');
    this.#bar = this.querySelector('.sda-slider__progress span');
    this.#arrows = [...this.querySelectorAll('.sda-arrow')];

    this.#track.addEventListener('scroll', () => this.#sync(), { signal, passive: true });
    this.#arrows.forEach((arrow, index) =>
      arrow.addEventListener('click', () => this.#scroll(index === 0 ? -1 : 1), { signal })
    );

    this.#observer = new ResizeObserver(() => this.#sync());
    this.#observer.observe(this.#track);
    this.#sync();
  }

  disconnectedCallback() {
    this.#controller.abort();
    this.#observer?.disconnect();
  }

  #scroll(direction) {
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#track.scrollBy({ left: direction * this.#track.clientWidth * 0.8, behavior: calm ? 'auto' : 'smooth' });
  }

  #sync() {
    const { scrollWidth, clientWidth, scrollLeft } = this.#track;
    const max = scrollWidth - clientWidth;

    this.classList.toggle('is-static', max < 2);
    this.#bar.style.width = `${(clientWidth / scrollWidth) * 100}%`;
    this.#bar.style.left = `${(scrollLeft / scrollWidth) * 100}%`;
    this.#arrows[0].disabled = scrollLeft < 2;
    this.#arrows[1].disabled = scrollLeft > max - 2;
  }
}

customElements.define('scroll-slider', ScrollSlider);
